<template>
    <b-modal
      title="Alterar imagem de produto"
      no-close-on-backdrop
      size="lg"
      ok-only
      centered
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
      :busy="loading"
      ok-title="Fechar"
      ok-variant="danger"
    >
      <b-row class="container mb-5 mt-2 d-flex align-items-center justify-content-center">
        <h4>{{ photos.produto }}</h4>
      </b-row>

     <div class="container">
        <b-row>
          <b-col v-for="(photo, index) in photos.produto_fotos" :key="index">
            <div class="d-flex align-items-center justify-content-center">
              <img :src="linkFotos(photos.origem) + photo.foto_png" class="imgModal" />
            </div>

            <div v-if="photos.origem != 'Belenus'" class="d-flex align-items-center justify-content-center">
              <b-button variant="danger" class="ml-2" @click="deleteImage(photo.foto_png, photo.id )">
                <i class="fas fa-trash mr-2"></i>Excluir
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="photos.origem != 'Belenus'" class="mt-5">
          <b-col>
            <label> **Aceita somente imagem no formato <b>PNG</b></label>
            <input
              type="file"
              id="file"
              ref="file"
              class="form-control"
              lang="pt"
              accept="image/x-png"
            />
          </b-col>
    
          <b-col cols="2">
            <b-button
              class="btnUpload" 
              variant="success"
              @click="uploadImage()"
            >Salvar</b-button>
          </b-col>
        </b-row>
        <b-row v-else class="mt-5 d-flex align-items-center justify-content-center">
          <h3>
            <b-badge variant="danger">
              Não pode ser adicionada ou alterada imagem para esse produto
            </b-badge>
          </h3>
        </b-row>
     </div>
    </b-modal>
</template>

<script>
import { mapActions} from 'vuex';
import makeToast from 'Mixins/makeToast';

export default {
    name: 'ModalUploadImage',
    mixins: [makeToast],
    emits: ['newImageProduct'],

    data() {
      return {
        loading: false,
        photos:[],
        open: false,
        imageSelected: '',
      };
    },

    methods: {
      ...mapActions('files', ['uploadFileApiApp', 'deleteImageProduct']),

      toggleOpen({ photo = '' }) {
        this.open = !this.open;
        this.photos = photo;
        this.imageUp = null;
      },

      uploadImage() {
        const formData = new FormData();
        this.imageSelected = this.$refs.file.files[0];
        formData.append('file', this.imageSelected);
        formData.append('id', this.photos.id)
        formData.append('isProduct', true)

        this.loading = true;
        this.$store.dispatch('files/uploadFileApiAppCategoria', formData)
          .then((response) => {
            if(response.data.error == true) {
              this.makeToast('Oops!', response.data.message, 'danger');
            } else {
              this.imageSelected = '';
              this.makeToast('Sucesso!', 'Imagem salvo com sucesso', 'success');
              this.open = false;
              this.$emit('newImageProduct');
            }
          })
          .catch(() => {
            this.makeToast('Oops!', 'Não foi possível inserir sua imagem, tente novamente!', 'danger');
          })
          .finally(() => {
            this.loading = false;
          });
      },
      deleteImage(image, id){
        const data = {
          'imgDelete': image,
          'id': id
        }

        this.loading = true;
        this.$store.dispatch('files/deleteImageProduct', data)
          .then((response) => {            
            if(response.data.error == false){
              this.makeToast('Oops!', 'Imagem excluida com sucesso!', 'success');
              this.$emit('newImageProduct');
            }else {
              this.makeToast('Oops!', 'Houve um erro ao excluir a imagem, tente novamente!', 'danger');  
            }
          })
          .catch(() => {
            this.makeToast('Oops!', 'Houve um erro ao excluir a imagem, tente novamente!', 'danger');
          })
          .finally(() => {
          this.loading = false;
          this.open = false;
        });
      },

      linkFotos(origem) {
        if(origem == 'Belenus') {
          return 'https://storage.googleapis.com/fotos-prd/';
        } else {
          return process.env.VUE_APP_FOTOS_URL;
        }
      },
    }
}
</script>

<style scoped>

.imgModal {
  width: 200px;
  height: 150px;
}
.btnUpload{
  margin-top: 31px;
}
</style>